import { normalizeKoreanText } from './fixKoreanText';
const COURIER_DISPLAY_NAMES = {
    hanjin: '\uD55C\uC9C4\uD0DD\uBC30',
    kyungdong: '\uACBD\uB3D9\uD0DD\uBC30',
    cheonil: '\uCC9C\uC77C\uD0DD\uBC30',
};
const COURIER_TYPE_ALIASES = {
    hanjin: ['\uD55C\uC9C4', '\uD55C\uC9C4\uD0DD\uBC30', 'hanjin', 'hj'],
    kyungdong: ['\uACBD\uB3D9', '\uACBD\uB3D9\uD0DD\uBC30', '\uACBD\uB3D9\uD654\uBB3C', 'kyungdong', 'kd', 'kdexp'],
    cheonil: ['\uCC9C\uC77C', '\uCC9C\uC77C\uD0DD\uBC30', 'cheonil', 'chunil', '1000'],
};
function normalizeCourierAliasValue(value) {
    return normalizeKoreanText(String(value || ''))
        .replace(/[\s/_()-]+/g, '')
        .trim()
        .toLowerCase();
}
function matchesCourierAliases(normalized, aliases) {
    return aliases.some((alias) => normalized.includes(normalizeCourierAliasValue(alias)));
}
export function maskName(name) {
    if (!name || name.length < 2)
        return name;
    if (name.length === 2) {
        return name[0] + '*';
    }
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
}
export function maskPhone(phone) {
    if (!phone)
        return phone;
    const digits = phone.replace(/[^0-9]/g, '');
    if (digits.length < 4)
        return phone;
    const masked = digits.slice(0, -4) + '****';
    if (phone.includes('-')) {
        return masked.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-****');
    }
    return masked;
}
export function maskDetailAddress(address) {
    if (!address)
        return address;
    const idx = address.lastIndexOf(' ');
    if (idx === -1)
        return address;
    return address.slice(0, idx) + ' ****';
}
export function getBoxTypCdByFee(fee) {
    const map = {
        '2500': 'A',
        '3000': 'B',
        '4000': 'C',
        '5000': 'D',
    };
    return map[String(fee)] || 'A';
}
export function getCourierType(shipComp) {
    const normalized = normalizeCourierAliasValue(shipComp);
    if (!normalized)
        return 'unknown';
    if (matchesCourierAliases(normalized, COURIER_TYPE_ALIASES.hanjin))
        return 'hanjin';
    if (matchesCourierAliases(normalized, COURIER_TYPE_ALIASES.kyungdong))
        return 'kyungdong';
    if (matchesCourierAliases(normalized, COURIER_TYPE_ALIASES.cheonil))
        return 'cheonil';
    return 'unknown';
}
export function getCourierDisplayName(courierType) {
    return COURIER_DISPLAY_NAMES[courierType] || '\uC54C \uC218 \uC5C6\uB294 \uD0DD\uBC30\uC0AC';
}
export function getCourierColor(courierType) {
    switch (courierType) {
        case 'hanjin':
            return '#000000';
        case 'kyungdong':
            return '#0066cc';
        case 'cheonil':
            return '#ff6600';
        default:
            return '#666666';
    }
}
